/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CalculateStorageDaysResponse
 */
export interface CalculateStorageDaysResponse {
  /**
   *
   * @type {number}
   * @memberof CalculateStorageDaysResponse
   */
  storageDays: number;
}

/**
 * Check if a given object implements the CalculateStorageDaysResponse interface.
 */
export function instanceOfCalculateStorageDaysResponse(
  value: object,
): value is CalculateStorageDaysResponse {
  if (!("storageDays" in value) || value["storageDays"] === undefined)
    return false;
  return true;
}

export function CalculateStorageDaysResponseFromJSON(
  json: any,
): CalculateStorageDaysResponse {
  return CalculateStorageDaysResponseFromJSONTyped(json, false);
}

export function CalculateStorageDaysResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CalculateStorageDaysResponse {
  if (json == null) {
    return json;
  }
  return {
    storageDays: json["storageDays"],
  };
}

export function CalculateStorageDaysResponseToJSON(
  json: any,
): CalculateStorageDaysResponse {
  return CalculateStorageDaysResponseToJSONTyped(json, false);
}

export function CalculateStorageDaysResponseToJSONTyped(
  value?: CalculateStorageDaysResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    storageDays: value["storageDays"],
  };
}
